import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/AppIcon';
import Logo from '../../assets/images/logo.png';
import { registerDeviceToken } from '../../utils/firebase';

function LoginIndex() {
  const navigate = useNavigate();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  // Hardcoded credentials
  const VALID_USERNAME = 'admin';
  const VALID_PASSWORD = '1234';

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username === VALID_USERNAME && password === VALID_PASSWORD) {
      localStorage.setItem('token', 'fake-jwt-token');

      // Register push notifications after login.
      // Swallow errors so login always proceeds.
      try {
        await registerDeviceToken();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.warn('[Login] Could not register push token', err);
      }

      navigate('/salon-dashboard');
    } else {
      setError('نام کاربری یا رمز عبور اشتباه است');
    }
  };

  return (
    <div
      dir="rtl"
      className="flex h-screen flex-col justify-center px-6 py-12 lg:px-8 bg-background">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm p-3">
        <div className="flex justify-center">
          <img
            src={Logo}
            alt="Logo"
            className="h-24 w-auto rounded-2xl shadow-lg"
          />
        </div>
        <h2 className="mt-8 text-center text-2xl font-bold tracking-tight text-foreground">
          ورود به پنل مدیریت
        </h2>
        <p className="mt-2 text-center text-sm text-muted-foreground">
          نسخه تحت وب و موبایل ادمین
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Username */}
          <div>
            <label
              htmlFor="username"
              className="block text-sm font-medium text-foreground">
              نام کاربری
            </label>
            <div className="relative mt-2">
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground">
                <Icon name="User" size={18} />
              </div>
              <input
                id="username"
                name="username"
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="block w-full rounded-xl bg-muted px-3 py-3 pr-10 text-base text-foreground outline-none ring-1 ring-inset ring-border placeholder:text-muted-foreground focus:ring-2 focus:ring-primary sm:text-sm"
                placeholder="admin"
              />
            </div>
          </div>

          {/* Password */}
          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-foreground">
              رمز عبور
            </label>
            <div className="relative mt-2">
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground">
                <Icon name="Lock" size={18} />
              </div>
              <input
                id="password"
                name="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="block w-full rounded-xl bg-muted px-3 py-3 pr-10 text-base text-foreground outline-none ring-1 ring-inset ring-border placeholder:text-muted-foreground focus:ring-2 focus:ring-primary sm:text-sm"
                placeholder="••••"
              />
            </div>
          </div>

          {/* Error */}
          {error && (
            <p className="text-error text-sm text-center bg-error/10 py-2 rounded-lg">
              {error}
            </p>
          )}

          {/* Submit */}
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-xl bg-primary px-3 py-3 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary transition-colors active:scale-[0.98]">
              ورود به داشبورد
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default LoginIndex;
